import CryptoJS from 'crypto-js';
import { getCookieAmend } from './cookie';
import sha256 from 'crypto-js/sha256';
const { Base64 } = CryptoJS.enc;
// AES-GCM 加密方法
// async function exportCryptoKey(key) {
//     const exported = await window.crypto.subtle.exportKey(
//         'jwk',
//         key
//     );
//     return exported.k;
// }

function hexToArrayBuffer(hex) {
  if (!hex) return new Uint8Array([]); 
  const buffer = new Uint8Array(hex.match(/[\da-f]{2}/gi).map(h => parseInt(h, 16)));
  return buffer;
}

function base64ToHex(text) {
  const str = window.atob(text);
  let current = '';
  let result = '';
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i).toString(16) < 10) {
      current = `0${str.charCodeAt(i).toString(16)}`;
    } else {
      current = str.charCodeAt(i).toString(16);
    }
    result += current;
    // result += str.charCodeAt(i).toString(16)
    //   .padStart(2, 0);
  }
  return result;
}

function mergeCiphertextAndTag(ciphertext, tag) {
  if (ciphertext && tag) {
    const cipher = base64ToHex(ciphertext) + base64ToHex(tag);
    return hexToArrayBuffer(cipher);
  }
  return null;
  // todo
}

function importKey(array) {
  return window.crypto.subtle.importKey(
    'raw',
    array,
    {
      name: 'AES-GCM',
    },
    false,
    ['encrypt', 'decrypt'],
  );
}

// function arrayBufferToBase64(buffer: Buffer) {
//     let binary = '';
//     const bytes = new Uint8Array(buffer);
//     const len = bytes.byteLength;
//     for (let i = 0; i < len; i++) {
//         binary += String.fromCharCode(bytes[i]);
//     }
//     // var binary = Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('')
//     return window.btoa(binary);
// }

function arrayBufferTohex(buffer) {
  return Array.prototype.map
    .call(new Uint8Array(buffer), x => `00${x.toString(16)}`.slice(-2))
    .join('');
}

export async function encryptMessage(key, message) {
  let exKey = key;
  if (typeof key === 'string') {
    // eslint-disable-next-line
    key = hexToArrayBuffer(key);
    exKey = await importKey(key);
  }

  let encoded = message;
  if (typeof message === 'string') {
    const enc = new TextEncoder();
    encoded = enc.encode(message);
  }

  // 后台要求的 iv 和 add 算法
  const randStartIdx = Math.floor(Math.random() * (key.length - 12));
  const iv = key.slice(randStartIdx, randStartIdx + 12);
  // const additionalData = key.slice(0, 0);
  // const additionalData = key.slice(0, 16);

  // 加密
  const encrypted = await window.crypto.subtle.encrypt(
    {
      name: 'AES-GCM',
      iv,
      tagLength: 128,
    },
    exKey,
    encoded,
  );

  // AES-GCM 解密结果将 mactag 附在最后的 128bits，将密文和 tag 分离
  // const result = {
  //     cipher: arrayBufferToBase64(encrypted.slice(0, encrypted.byteLength - 16)),
  //     tag: arrayBufferToBase64(encrypted.slice(encrypted.byteLength - 16))
  // };
  const encryptedArray = new Uint8Array(encrypted);
  const result = new Uint8Array(iv.length + encryptedArray.length);
  result.set(iv);
  result.set(encryptedArray, iv.length);
  return result;
  // 尝试解密
  // var d = {
  // 	key: exKey,
  // 	ciphertext: result.cipher,
  // 	tag: result.tag,
  // 	iv,
  // 	additionalData
  // }
  // console.log('d', d)
  // decryptMessage(d)
}

async function aESGCM(message, key) {
  if (key) {
    return encryptMessage(key, message);
  }
  return window.crypto.subtle
    .generateKey(
      {
        name: 'AES-GCM',
        length: 256,
      },
      true,
      ['encrypt', 'decrypt'],
    )
    .then(skey => encryptMessage(skey, message))
    .catch(err => err);
}

async function decryptMessage(options) {
  let {
    key,

    iv,
    additionalData,
  } = options;
  const { ciphertext, tag } = options;

  let exKey = key;

  if (typeof key === 'string') {
    key = hexToArrayBuffer(key);
    exKey = await importKey(key);
  }

  if (!iv) {
    // 后台要求的 iv 和 add 算法
    iv = key.slice(key.length - 12, key.length);
    // iv = hexToArrayBuffer(iv);
  }
  if (!additionalData) {
    // 后台要求的 iv 和 add 算法
    additionalData = key.slice(0, 16);
    // additionalData = hexToArrayBuffer(additionalData);
  }

  const cipher = mergeCiphertextAndTag(ciphertext, tag);

  const decrypted = await window.crypto.subtle.decrypt(
    {
      name: 'AES-GCM',
      iv,
      additionalData,
    },
    exKey,
    cipher,
  );

  return arrayBufferTohex(decrypted);

  // let dec = new TextDecoder();
  // console.log('decrypt', dec.decode(decrypted))
  // return dec.decode(decrypted);
}

function AESGCMDecrypted(options) {
  const { ciphertext, key, tag } = options;

  if (key) {
    return decryptMessage({
      key,
      ciphertext,
      tag,
    });
  }
  return window.crypto.subtle
    .generateKey(
      {
        name: 'AES-GCM',
        length: 256,
      },
      true,
      ['encrypt', 'decrypt'],
    )
    .then(skey => decryptMessage(skey /* , message */))
    .catch(err => err);
}

// 生成协商密钥
async function createEcdh() {
  try {
    // 浏览器不支持情况下，启动降级方案
    if (!(window.crypto && window.crypto.subtle)) {
      return null;
    }
    // 16进制转数组
    const hex2Arr = (str) => {
      if (!str) {
        return new Uint8Array();
      }
      const arr = [];
      for (let i = 0, len = str.length; i < len; i += 2) {
        arr.push(parseInt(str.substr(i, 2), 16));
      }
      return new Uint8Array(arr);
    };
    // 数组转16进制
    const buf2Hex = buf => (
      Array.from(new Uint8Array(buf))
        .map(x => `00${x.toString(16)}`.slice(-2))
        .join('')
    );
    const serPublicKeyHex = '0484705184c0cdfdb1ace0268bcae87f5320913222d3c71ca777defe3999e88c2c8ed1c5fed78287b90c7d8b01b81c9b7db20bb669e4899418c2038637d8bb4f13';
    const serPublicKey = hex2Arr(serPublicKeyHex);
    const bobKey = await window.crypto.subtle.generateKey(
      {
        name: 'ECDH',
        namedCurve: 'P-256',
      },
      false,
      ['deriveKey', 'deriveBits'],
    );
    // 生成公钥
    const clientPublicKeyExported = await window.crypto.subtle.exportKey('raw', bobKey.publicKey);
    const clientPublicKeyHex = buf2Hex(clientPublicKeyExported); // 公钥
    const aliceKeyImported = await window.crypto.subtle.importKey(
      'raw',
      serPublicKey,
      {
        name: 'ECDH',
        namedCurve: 'P-256',
      },
      true,
      [],
    );
    const sharedSecret = await window.crypto.subtle.deriveBits(
      {
        name: 'ECDH',
        // namedCurve:'P-256',
        public: aliceKeyImported,
      },
      bobKey.privateKey,
      256,
    );
    const sharedSecretHex = buf2Hex(sharedSecret); // 协商密钥转16进制
    return {
      clientPublicKeyHex, // 客户端公钥
      sharedSecretHex, // 协商密钥
    };
  } catch (e) {
    return null;
  }
}
// 登陆加密
async function getEncryptedFormDataLogin(option) {
  const promise = new Promise(async (resolve) => {
    const { account, areaNumber, pwd } = option;
    let { accountType } = option;
    // 明文的账号信息
    const accountInfo = Object.assign(
      {
        user_id: account,
        user_type: accountType,
      },
      (accountType = { area_id: areaNumber }),
    );
    // let eccKeyInfoObj; // ecc密钥对象
    let authInfo; // 认证信息，LINE传code, FB传access_token, 密码传AES(sha256(pwd)，AuthInfo)
    const eccKeyInfoObj = await createEcdh(); // 动态获取协商密钥以及客户端公钥
    if (eccKeyInfoObj) {
      // 客户端支持ecc加解密
      const {
        // clientPublicKeyHex,//客户端公钥
        sharedSecretHex, // 协商密钥
      } = eccKeyInfoObj;
      // wetv｜iflix业务登陆
      const data = {
        account: accountInfo,
        auth_token: {
          login_token: '',
        },
        device_info: {
          guid: getCookieAmend('guid'),
          vplatform: 2,
        },
        timestamp: Math.floor(Date.now() / 1000),
      };
      switch (getCookieAmend('video_appid')) {
        case '1200012': // wetv
          data.auth_token.login_token = arrayBufferTohex(new Uint8Array(Buffer.from(sha256(pwd).toString(CryptoJS.enc.Hex), 'hex')));
          break;
        case '1200016': // iflix
          data.auth_token.login_token = pwd || '';
          break;
        default:
          break;
      }
      const encrypted = await aESGCM(JSON.stringify(data), sharedSecretHex);

      authInfo = arrayBufferTohex(encrypted);
    } else {
      // 客户端不支持ecc加解密
      // 根据平台id区分wetv，还是iflix
      switch (getCookieAmend('video_appid')) {
        case '1200012': // wetv
          authInfo = sha256(pwd).toString(CryptoJS.enc.Hex);
          break;
        case '1200016': // iflix
          authInfo = pwd;
          break;
        default:
          break;
      }
    }
    const reqOut = {
      account: accountInfo,
      auth_info: authInfo,
      key_info: {},
    };
    // 是否存在协商密钥对象，存在情况下以加密形式传递
    if (eccKeyInfoObj && eccKeyInfoObj.clientPublicKeyHex) {
      reqOut.key_info = {
        client_pub: eccKeyInfoObj.clientPublicKeyHex,
        key_version: 1,
      };
    }
    resolve({
      ...reqOut,
    });
  });
  return promise;
}
export {
  aESGCM,
  AESGCMDecrypted,
  sha256,
  Base64,
  hexToArrayBuffer,
  base64ToHex,
  mergeCiphertextAndTag,
  importKey,
  arrayBufferTohex,
  createEcdh,
  decryptMessage,
  getEncryptedFormDataLogin,
  CryptoJS,
};
